import { render } from "./EntrepriseView.vue?vue&type=template&id=0528824e"
import script from "./EntrepriseView.vue?vue&type=script&lang=js"
export * from "./EntrepriseView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LCE\\Documents\\code\\front-end LCE\\centre-sante-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__